import WithAuth from "../components/hoc/with-auth";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx";
import OrdersPage from "../components/pages/orders";

const Orders = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Orders" pageDesc="List of all the orders">
          <OrdersPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default Orders;
